import { parseText } from '../../utils/string/parseText';
import { useTranslation } from '../../hooks/useTranslation';

type CookiePolicySection = {
  description: string[];
  heading: string;
  links?: string[];
};

/**
 * Static per-locale cookie policy.
 *
 * This used to embed OneTrust's generated cookie table and call
 * `OneTrust.initializeCookiePolicyHtml()`. Analytics now run cookielessly (see
 * services/posthog/init.ts) so the site sets no cookies and OneTrust is no
 * longer loaded; only the locale's own copy is rendered.
 *
 * Note `en-EN` (the UK) ships no `cookiePolicy` — the UK footer links out to the
 * D&G corporate notice instead, and Layout filters the UK out of the country
 * switcher on this route.
 */
export const CookiePolicyPage = () => {
  const { data } = useTranslation();

  if (!data?.cookiePolicy) return null;

  const { title, sections } = data.cookiePolicy;

  return (
    <div className="w-11/12 md:max-w-[75%] mx-auto grid grid-cols-12 *:col-span-12">
      <h1 className="text-h4 mt-space-600 mb-space-300">{title}</h1>

      {sections.map((section: CookiePolicySection, index) => (
        <section key={index} className="mb-space-600">
          <h2 className="text-h6 mt-space-300 mb-space-300">{section.heading}</h2>
          {section.description.map((paragraph, pIndex) => (
            <p key={pIndex} className="mb-space-300">
              {parseText(paragraph, section.links ?? [])}
            </p>
          ))}
        </section>
      ))}
    </div>
  );
};
